import React from 'react';
import TuneIcon from '@material-ui/icons/Tune';
import HelpIcon from '@material-ui/icons/Help';

import '../styles/section.css';
import '../styles/tables.css';
import RespUtils from '../util/RespUtils';
import constants from '../constants';


class StatusTagList extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
        <div className="tablesBg">
            <div className="sectionHeader">
              <div className="sectionTitle">
                  <span>{this.renderStatusTags()} </span>
              </div>
              <button onClick={this.props.showColumnSettings} className="tourColumnSettings animLink"><TuneIcon /></button>
              {/* <button onClick={this.props.showHelp} className="tourHelp animLink"><HelpIcon /></button> */}
            </div>
        </div>
    );
  }

  renderStatusTags() {
    if (!this.props.statusSummary) {
      return "";
    }
    
    if (RespUtils.isMobileView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="animLink" href={"/validators/All"}>{this.formatView("All ", (this.props.statusSummary.Total), "All")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Bonded"}>{this.formatView("Bonded ", this.props.statusSummary.Bonded, "Bonded")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Jailed"}>{this.formatView("Jailed ", this.props.statusSummary.Jailed, "Jailed")}</a> </td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="animLink" href={"/validators/All"}>{this.formatView("All ", (this.props.statusSummary.Total), "All")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Bonded"}>{this.formatView("Bonded ", this.props.statusSummary.Bonded, "Bonded")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Jailed"}>{this.formatView("Jailed ", this.props.statusSummary.Jailed, "Jailed")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Unbonded"}>{this.formatView("Unbonded ", this.props.statusSummary.Unbonded, "Unbonded")}</a> </td>
          <td className="view-tag"><a className="animLink" href={"/validators/Unbonding"}>{this.formatView("Unbonding ", this.props.statusSummary.Unbonding, "Unbonded")}</a> </td>
        </tr></tbody></table></div>);
    }
  }

  formatView(label, count, status) {
    if (count != null) {
      label = label + count;
    } else {
      label = label + "0";
    }

    // console.log("in formatView for: ", label, status);
    if (this.props.match && this.props.match.params.status) {
      if (this.props.match.params.status == status) {
        // console.log("status matched: ", this.props.match.params.status, status);
        return <b><u>{label}</u></b>
      } else {
        return label;
      }
    } else if (status == constants.app.defaultValidatorViewStatus) {
      // console.log("returning from AllEligible");
      return <b><u>{label}</u></b>
    } else if (status != null) {
      // console.log("returning from status not null");
      return label;
    }

    // console.log("returning from end");
    return <b><u>{label}</u></b>
  }

}

export default StatusTagList;



// WEBPACK FOOTER //
// ./src/main/StatusTagList.js